import { HeaderNavigationItem } from "components/UI/DynamicHeaderNavigation/atoms/headerNavigationAtom.ts";
import { Route as AccountOverviewPage } from "routes/_authenticated/account/_layout/";
import { Route as ProgramsCatalogPage } from "routes/_authenticated/account/_layout/catalog/";
import { Route as PartnersCatalogPage } from "routes/_authenticated/account/_layout/partners/";
import { Route as AccountSettingsPage } from "routes/_authenticated/account/_layout/settings/";

import type { AnyRoute } from "@tanstack/react-router";

export function getAccountOverviewHeaderItems(): HeaderNavigationItem[] {
    return [{ route: AccountOverviewPage as AnyRoute, customLabel: "common.overview" }];
}

export function getProgramsCatalogHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ProgramsCatalogPage as AnyRoute, customLabel: "common.overview" }];
}

export function getPartnersCatalogHeaderItems(): HeaderNavigationItem[] {
    return [{ route: PartnersCatalogPage as AnyRoute, customLabel: "common.overview" }];
}

export function getAccountSettingsHeaderItems(): HeaderNavigationItem[] {
    return [{ route: AccountSettingsPage as AnyRoute, customLabel: "common.overview" }];
}
